<template>
  <h2 class="cg-section-title mb-3 mt-4">Planned by Soldera</h2>
  <div class="card mb-4">
    <div class="card-body">
      <div v-for="(row, index) in rows" :key="index" class="cg-plan-row">
        <p
          class="cg-micro mb-0 pt-1"
          :class="{ 'text-warning-emphasis': row.whenWarn }"
        >
          {{ row.when }}
        </p>
        <div class="cg-plan-rail">
          <span class="cg-plan-dot" :class="`cg-plan-dot--${row.dot}`" />
        </div>
        <div class="pb-4">
          <p class="mb-1 fw-semibold small">{{ row.title }}</p>
          <p class="mb-1 small">
            <span class="cg-micro">Why</span>
            <span class="text-body-secondary">·</span> {{ row.why }}
          </p>
          <p class="mb-0 text-body-secondary small">{{ row.detail }}</p>
          <div class="d-flex flex-wrap gap-2 mt-2 cg-chips">
            <span v-for="chip in row.chips" :key="chip.name" class="cg-chip">
              <span class="text-body-secondary">{{ chip.name }}</span>
              <span class="fw-semibold cg-tabular">{{ chip.value }}</span>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { PlanRow } from "@/compliance_groups/fixture/derive";

defineProps<{ rows: PlanRow[] }>();
</script>

<style scoped lang="scss">
.cg-plan-row {
  display: grid;
  grid-template-columns: 92px 1px minmax(0, 1fr);
  column-gap: 16px;
}
.cg-plan-rail {
  position: relative;
  background: var(--phoenix-card-border-color);
}
.cg-plan-dot {
  position: absolute;
  top: 2px;
  left: -4px;
  width: 9px;
  height: 9px;
  border-radius: 999px;
  box-shadow: 0 0 0 3px var(--phoenix-emphasis-bg);
  &--forest {
    background: var(--phoenix-primary);
  }
  &--muted {
    background: var(--phoenix-gray-500);
  }
  &--warn {
    background: var(--phoenix-orange-400);
  }
}
.cg-chips {
  max-width: 54ch;
}
</style>
